import React, { Component } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
  Backdrop
} from "@mui/material";
import Sidebar from "../Sidebar";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import base from "../base.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from 'react-toastify';
import loader from '../img/ltm.gif'


const drawerWidth = 80;
export class Vendors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ////// Personal Information (Vendors)

      vendor_personal_first_name: "",
      vendor_personal_last_name: "",
      vendor_personal_sirname: "",

      //////// Contact Details
      vender_personal_address: "",
      vender_personal_email: "",
      vendor_login_passcode : "",
      vender_personal_city: "",
      vender_personal_state: "",
      vender_personal_pincode: "",
      vendor_personal_whatsapp_no: "",
      vendor_personal_contact_number: "",

      ////////////  ID information
      vender_personal_abc_id: "",
      vendor_personal_pan_no: "",
      vendor_personal_adharcard_number: "",

      //////////  Financial Details
      vender_personal_bank_account_no: "",
      vendor_personal_bank_ifsc_code: "",
      vendor_personal_bank_name: "",
      vender_personal_bank_account_type: "",
      vendor_personal_bank_branch_name: "",
      vendor_personal_bank_account_holder_name: "",

      /////////// Attachment Details

      vendor_pan_card_docs: "",
      vendor_adhar_card_docs: "",
      vendor_bank_account_docs: "",
      vendor_address_docs: "",


      vendor_photo: [],
      vendor_video: [],
      vendors_thumb_nails_img : "",

      /////////////// Bussiness information //////////

      business_name: "",
      business_contact_no: "",
      bussiness_email_id: "",
      bussiness_exprence: "",

      bussiness_category: "",
      bussiness_sub_category: "",
      bussiness_desc : "",


      //////////// location ///////////

      latitude : 0,
      longitude : 0,

      ///// swithch button for page change

      category_select_list : [],
      sub_category_List : [],


      

      is_switch_case: true,
      is_vendor_delete : false,
      is_loader_shows  : false,
    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  handleChangeee = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };



  save = () => {

      if(this.state.vendor_photo.length > 0 &&
      this.state.vendor_video.length > 0  &&
      this.state.vendors_thumb_nails_img  !== "" &&
      this.state.business_name !== "" &&
      this.state.business_contact_no !== "" &&
      this.state.bussiness_email_id !== "" &&
      this.state.bussiness_exprence !== "" &&
      this.state.bussiness_category !== "" && this.state.bussiness_desc!=="" && this.state.vendor_login_passcode!=="" &&
      this.state.bussiness_sub_category !== "" ){

    let formdata = new FormData();

    for (let index = 0; index < this.state.vendor_video.length; index++) {
        formdata.append('vendor_video', this.state.vendor_video[index] )
    }

  
    for (let index = 0; index < this.state.vendor_photo.length; index++) {
        formdata.append('vendor_photo', this.state.vendor_photo[index] )
    }

    ///// personal contact
    formdata.append(
      "vendor_personal_first_name",
      this.state.vendor_personal_first_name
    );
    formdata.append(
      "vendor_personal_last_name",
      this.state.vendor_personal_last_name
    );
    formdata.append(
      "vendor_personal_sirname",
      this.state.vendor_personal_sirname
    );
 formdata.append("bussiness_desc",this.state.bussiness_desc)
    //////// Contact Details
    formdata.append(
      "vender_personal_address",
      this.state.vender_personal_address
    );
    formdata.append("vender_personal_email", this.state.vender_personal_email);
      formdata.append("vendor_login_passcode", this.state.vendor_login_passcode);
    formdata.append("vender_personal_city", this.state.vender_personal_city);
    formdata.append("vender_personal_state", this.state.vender_personal_state);
    formdata.append(
      "vender_personal_pincode",
      this.state.vender_personal_pincode
    );
    formdata.append(
      "vendor_personal_whatsapp_no",
      this.state.vendor_personal_whatsapp_no
    );
    formdata.append(
      "vendor_personal_contact_number",
      this.state.vendor_personal_contact_number
    );

    //////// id information
    formdata.append(
      "vender_personal_abc_id",
      this.state.vender_personal_abc_id
    );
    formdata.append(
      "vendor_personal_adharcard_number",
      this.state.vendor_personal_adharcard_number
    );
    formdata.append(
      "vendor_personal_pan_no",
      this.state.vendor_personal_pan_no
    );

    //////// Financial Details
    formdata.append(
      "vender_personal_bank_account_no",
      this.state.vender_personal_bank_account_no
    );
    formdata.append(
      "vendor_personal_bank_ifsc_code",
      this.state.vendor_personal_bank_ifsc_code
    );
    formdata.append(
      "vendor_personal_bank_name",
      this.state.vendor_personal_bank_name
    );
    formdata.append(
      "vender_personal_bank_account_type",
      this.state.vender_personal_bank_account_type
    );
    formdata.append(
      "vendor_personal_bank_branch_name",
      this.state.vendor_personal_bank_branch_name
    );
    formdata.append(
      "vendor_personal_bank_account_holder_name",
      this.state.vendor_personal_bank_account_holder_name
    );

    //////// Attachment Details
    formdata.append("vendor_pan_card_docs", this.state.vendor_pan_card_docs);
    formdata.append(
      "vendor_adhar_card_docs",
      this.state.vendor_adhar_card_docs
    );

    formdata.append(
      "vendor_bank_account_docs",
      this.state.vendor_bank_account_docs
    );
    formdata.append("vendor_address_docs", this.state.vendor_address_docs);
    formdata.append("vendors_thumb_nails_img",this.state.vendors_thumb_nails_img)

    //////// Bussiness Information (Vendors)
    formdata.append("business_name", this.state.business_name);
    formdata.append("business_contact_no", this.state.business_contact_no);
    formdata.append("bussiness_email_id", this.state.bussiness_email_id);
    formdata.append("bussiness_exprence", this.state.bussiness_exprence);
    formdata.append("bussiness_category", this.state.bussiness_category);
    formdata.append(
      "bussiness_sub_category",
      this.state.bussiness_sub_category
    );

    ////////////// location /////////////////////////
    formdata.append('latitude',this.state.latitude)
    formdata.append('longitude',this.state.longitude)



    
    this.setState({is_loader_shows : true},()=>{
       fetch(`${base.base_url}/admin/addvendor`, {
      /*
        headers: {
                                "content-type": "multipart/form-data",
                              },
                              */
      method: "post",
      body: formdata,
    })
      .then((res) => {
        return res.json();
      })
      .then(() => {
        this.setState({is_loader_shows:false},()=>{
           this.props.navigate('/VendorsList')
        });
      
      }); 
    })

  




    }else{

     this.alertMessage("Fill All Fields")


    }

  };



componentDidMount(){
  this.retriveCategoryList();
}


   
  retriveCategoryList=()=>{
    fetch(
      `${base.base_url}/admin/category/retriveCategoryListForselect`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          category_select_list: result.data,
        });
      });
  }



alertMessage=(s)=>{
  toast.error(`${s}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    //transition: Bounce,
    });
}




  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                height: 47,
                //  width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>
                Add New Vendors
              </Typography>

              <Link to="/VendorsList">
                <Button
                  variant="contained"
                  size="samll"
                  startIcon={
                    <FormatListNumberedOutlinedIcon
                      sx={{ height: 20, width: 20 }}
                    />
                  }
                  disableElevation
                  sx={{
                    height: 25,
                    fontSize: 13,
                    textTransform: "none",
                    backgroundColor: "#288ade",
                    mr: 1,
                  }}
                >
                  Vendor List
                </Button>
              </Link>
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "block" : "none",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Personal Information (Vendors)
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Vendor First Name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="first name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_first_name"
                          value={this.state.vendor_personal_first_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Last Name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Middle Name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_last_name"
                          value={this.state.vendor_personal_last_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Sir Name
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Sir Name"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_sirname"
                          value={this.state.vendor_personal_sirname}
                          onChange={this.handleChange}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>

              <Box sx={{ mt: 1 }}>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                    Bussiness Contact Details :-
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Address
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          minRows={2}
                          multiline
                          placeholder="Enter Address Here"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vender_personal_address"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          City
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="City"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vender_personal_city"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          State
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="State"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vender_personal_state"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Pincode
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Pincode"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vender_personal_pincode"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Whatsapp No
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Whatsapp No"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_whatsapp_no"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Contact Number
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_contact_number"
                          placeholder="Phone no"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Email
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Email id"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vender_personal_email"
                          onChange={this.handleChange}
                        />
                      </Grid>


                     <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Password
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="password"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_login_passcode"
                          onChange={this.handleChange}
                        />
                      </Grid>

                         <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Latitude
                        </Typography>
                        <TextField
                          size="small"
                          type="number"
                          fullWidth
                          value={this.state.latitude}
                          placeholder="latitude"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="latitude"
                          onChange={this.handleChange}
                        />
                      </Grid>


                         <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                        Longitude
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                            type="number"
                          placeholder="longitude"
                          value={this.state.longitude}
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="longitude"
                          onChange={this.handleChange}
                        />
                      </Grid>

                    </Grid>
                  </Box>
                </Paper>
              </Box>

              <Box sx={{ mt: 1 }}>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      ID information
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          ABC ID
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Abc Id"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vender_personal_abc_id"
                          onChange={this.handleChange}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Pan no
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Pan no"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_pan_no"
                          onChange={this.handleChange}
                        />
                      </Grid>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Adhar card no
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Adhar Card No"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_adharcard_number"
                          value={this.state.email}
                          onChange={this.handleChange}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>

              <Box sx={{ mt: 1 }}>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Financial Details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bank Account No
                        </Typography>
                        <TextField
                          size="small"
                          placeholder="Account No"
                          fullWidth
                          onChange={this.handleChange}
                          name="vender_personal_bank_account_no"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "bold" },
                          }}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          IFSC Code
                        </Typography>
                        <TextField
                          placeholder="IFSC Code"
                          size="small"
                          fullWidth
                          name="vendor_personal_bank_ifsc_code"
                          onChange={this.handleChange}
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "bold" },
                          }}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bank Name
                        </Typography>
                        <TextField
                          size="small"
                          name="vendor_personal_bank_name"
                          onChange={this.handleChange}
                          placeholder="Bank Name"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "bold" },
                          }}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Account Type
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          name="vender_personal_bank_account_type"
                          onChange={this.handleChange}
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "bold" },
                          }}
                          select
                        >
                          {["saving", "current"].map((option) => (
                            <MenuItem
                              key={option}
                              value={option}
                              sx={{ fontSize: 12 }}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Branch Name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Branch Name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_bank_branch_name"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Account Holder Name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Account Holder Name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="vendor_personal_bank_account_holder_name"
                          onChange={this.handleChange}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>

              <Box sx={{ mt: 1 }}>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Attachment Details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Pan Card Photo
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="vendor_pan_card_docs"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 1MB, JPG or PNG.
                        </Typography>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Adhar Card
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="vendor_adhar_card_docs"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 1MB, JPG or PNG.
                        </Typography>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bank Account Photo
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="vendor_bank_account_docs"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 1MB, JPG or PNG.
                        </Typography>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Address proof
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="vendor_address_docs"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 1MB, JPG or PNG.
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>

              <Box sx={{ mt: 2, display: "flex", flexDirection: "row" }}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ textTransform: "none", height: 30 }}
                  onClick={() => {
                    if ( 
                                 this.state.vendor_personal_first_name !== "" &&
                      this.state.vendor_personal_last_name !== "" &&
                      this.state.vendor_personal_sirname !== "" &&
                      this.state.vender_personal_address !== "" &&
                      this.state.vender_personal_email !== "" &&
                      this.state.vender_personal_city !== "" &&
                      this.state.vender_personal_state !== "" &&
                      this.state.vender_personal_pincode !== "" &&
                      this.state.vendor_personal_whatsapp_no !== "" &&
                      this.state.vendor_personal_contact_number !== "" &&
                      this.state.vender_personal_abc_id !== "" &&
                      this.state.vendor_personal_pan_no !== "" &&
                      this.state.vendor_personal_adharcard_number !== "" &&
                      this.state.vender_personal_bank_account_no !== "" &&
                      this.state.vendor_personal_bank_ifsc_code !== "" &&
                      this.state.vendor_personal_bank_name !== "" &&
                      this.state.vender_personal_bank_account_type !== "" &&
                      this.state.vendor_personal_bank_branch_name !== "" &&
                      this.state.vendor_personal_bank_account_holder_name !==
                        "" &&
                      this.state.vendor_pan_card_docs !== "" &&
                      this.state.vendor_adhar_card_docs !== "" &&
                      this.state.vendor_bank_account_docs !== "" &&
                      this.state.vendor_address_docs !== ""
                
                    ) {
                      this.setState({ is_switch_case: false });
                    } else {
                      this.alertMessage("Fill All Fields")
                    }
                  }}
                >
                  Next
                </Button>
                <Button
                  size="small"
                  color="error"
                  variant="contained"
                  sx={{ textTransform: "none", height: 30, ml: 2 }}
                >
                  Cancel
                </Button>
              </Box>

              <br />
              <br />
              <br />
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "none" : "block",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 15,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Bussiness Information (Vendors)
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bussiness Name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Bussiness Name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="business_name"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bussiness Contact No
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Bussiness Contact No"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="business_contact_no"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bussiness Email Id
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Bussiness Email Id"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="bussiness_email_id"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Exprience
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Exprience"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="bussiness_exprence"
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Category
                        </Typography>
             
                        <TextField
                          size="small"
                          fullWidth
                          select
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="bussiness_category"
                          onChange={this.handleChange}
                        >
                          
                            {this.state.category_select_list.map((option) => (
                                    <MenuItem key={option.category_name} value={option.category_name} sx={{fontSize:11}} onClick={()=>this.setState({bussiness_category:option.category_name},()=>{
                                      
                                         fetch(
      `${base.base_url}/admin/subcategory/retriveSubCategoryListForselect`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body:JSON.stringify({
          category_id : option._id
        })
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        
        this.setState({
          sub_category_List : result.data,
        });
      });


                                    })}>
                                       {option.category_name}
                                    </MenuItem>
                                ))}

                        </TextField>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Sub Category
                        </Typography>
                        <TextField
                          size="small"
                          select
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="bussiness_sub_category"
                          onChange={this.handleChange}
                        >
                           {this.state.sub_category_List.map((option) => (
                                    <MenuItem key={option.sub_category_name} value={option.sub_category_name} sx={{fontSize:11}} onClick={()=>this.setState({bussiness_sub_category : option.sub_category_name})}>
                                       {option.sub_category_name}
                                    </MenuItem>
                                ))}
                        </TextField>
                      </Grid>

                         
                      <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bussiness Description (250 words)
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="bussiness_desc"
                          fullWidth
                          minRows={3}
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="bussiness_desc"
                          onChange={this.handleChange}
                        />
                      </Grid>



                    </Grid>
                  </Box>
                </Paper>
              </Box>

              <Box sx={{ mt: 1 }}>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 15,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Attachment Details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bussiness Photo(min 5)
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            name="vendor_photo"
                            onChange={this.handleChangeee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 1MB, JPG or PNG.
                        </Typography>
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Bussiness Video
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            name="vendor_video"
                            onChange={this.handleChangeee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 2mb .mp4 or other video formate.
                        </Typography>
                      </Grid>

           

                         <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Thumb Nail Image
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="vendors_thumb_nails_img"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                        <Typography sx={{ fontSize: 10, color: "grey", m: 1 }}>
                          Upload Max 1MB, JPG or PNG.
                        </Typography>
                      </Grid>

                    </Grid>
                  </Box>
                </Paper>
              </Box>

              <Box sx={{ mt: 2, display: "flex", flexDirection: "row" }}>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ textTransform: "none", height: 30 }}
                  onClick={this.save}
                >
                  Save Details
                </Button>
                <Button
                  size="small"
                  color="error"
                  variant="contained"
                  sx={{ textTransform: "none", height: 30, ml: 2 }}
                  onClick={() => this.setState({ is_switch_case: true })}
                >
                  Back
                </Button>
              </Box>

              <br />
              <br />
              <br />
            </Box>
          </Box>
        </Box>







    <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick={false}
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
//transition={Bounce}
/>




<Backdrop
sx={(theme) => ({ backgroundColor:'transparent', zIndex: theme.zIndex.drawer + 1 })}
open={this.state.is_loader_shows}
onClick={this.handleClose}
>
<Paper elevation={0} sx={{height:70,width:70,display:'flex',justifyContent:'center',alignItems:'center'}}>
<img  src={loader} style={{height:67,width:67}}/>
</Paper>
</Backdrop>



      </Box>
    );
  }
}

export default Vendors;


export function Vendorsc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return (<Vendors param={param} navigate={navigate}></Vendors>)
}
